import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=48f7b612&scoped=true&"
import script from "./TagList.vue?vue&type=script&lang=ts&"
export * from "./TagList.vue?vue&type=script&lang=ts&"
import style0 from "./TagList.vue?vue&type=style&index=0&id=48f7b612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f7b612",
  null
  
)

export default component.exports